/* ============================================================================
   cart-pdf.js — VanDouglasHout
   ----------------------------------------------------------------------------
   Genereert een opgemaakte HTML-pagina van de huidige winkelwagen,
   inclusief:
     - klikbare productpagina-links in de tabel
     - knop "Open winkelwagen" (herstelkoppeling)
     - knop "Mail naar iemand anders" (deel je cart)
     - knop "Vraag voorraadcheck" (mailt naar contact@vandouglashout.com)

   Wordt geladen via:
     <script src="{{ 'cart-pdf.js' | asset_url }}" defer></script>

   De knop op de winkelwagenpagina roept window.cartSavePDF() aan via onclick.
   ============================================================================ */

(function () {
  'use strict';

  var CONTACT_EMAIL = 'contact@vandouglashout.com';

  async function cartSavePDF() {
    var btn = document.getElementById('cart-pdf-btn');
    var originalText = btn ? btn.textContent : '';

    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Laden…';
    }

    try {
      // 1) Haal de actuele winkelwagen op
      var resp = await fetch('/cart.js');
      if (!resp.ok) throw new Error('Winkelwagen kon niet worden opgehaald.');
      var cart = await resp.json();

      if (!cart.items || cart.items.length === 0) {
        alert('Je winkelwagen is leeg.');
        return;
      }

      // 2) URLs bouwen
      var origin = window.location.origin;
      var itemString = cart.items
        .map(function (item) { return item.variant_id + ':' + item.quantity; })
        .join(',');
      var restoreUrl = origin + '/cart/' + itemString;
      var clearUrl   = origin + '/cart/clear';

      // 3) Hulpfuncties
      function fmtPrice(cents) {
        return new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: cart.currency
        }).format(cents / 100);
      }

      function escHtml(str) {
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function escAttr(str) {
        return escHtml(str);
      }

      var datum = new Date().toLocaleDateString('nl-NL', {
        day: 'numeric', month: 'long', year: 'numeric'
      });

      // 4) Productregels (met klikbare producttitels)
      var productRows = cart.items.map(function (item, i) {
        var productUrl = origin + item.url;
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<br><span style="color:#6b7280;font-size:11px;">' + escHtml(item.variant_title) + '</span>'
          : '';
        var sku = item.sku
          ? '<br><span style="color:#9ca3af;font-size:10px;">Art.nr: ' + escHtml(item.sku) + '</span>'
          : '';
        var rowBg = i % 2 === 1 ? 'background:#fafafa;' : '';
        return '<tr style="' + rowBg + '">'
          + '<td style="padding:10px 14px;border-bottom:1px solid #ebebeb;">'
          +   '<a href="' + escAttr(productUrl) + '" target="_blank" rel="noopener" '
          +     'style="color:#1a1a1a;text-decoration:none;font-weight:600;border-bottom:1px dotted #c0c0c0;">'
          +     escHtml(item.title)
          +   '</a>'
          +   variant + sku
          + '</td>'
          + '<td style="padding:10px 14px;border-bottom:1px solid #ebebeb;text-align:center;">'
          +   item.quantity
          + '</td>'
          + '<td style="padding:10px 14px;border-bottom:1px solid #ebebeb;text-align:right;">'
          +   fmtPrice(item.price)
          + '</td>'
          + '<td style="padding:10px 14px;border-bottom:1px solid #ebebeb;text-align:right;font-weight:700;">'
          +   fmtPrice(item.line_price)
          + '</td>'
          + '</tr>';
      }).join('');

      // 5) Kortingsregels (optioneel)
      var discountRows = '';
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
        discountRows += '<div class="trow"><span>Subtotaal</span><span>'
          + fmtPrice(cart.original_total_price) + '</span></div>';
        cart.cart_level_discount_applications.forEach(function (d) {
          discountRows += '<div class="trow discount"><span>Korting (' + escHtml(d.title)
            + ')</span><span>- ' + fmtPrice(d.total_allocated_amount) + '</span></div>';
        });
      }

      // 6) Plain-text productlijst voor mail bodies
      var productListText = cart.items.map(function (item) {
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? ' (' + item.variant_title + ')'
          : '';
        return '• ' + item.title + variant + ' — ' + item.quantity + 'x — ' + fmtPrice(item.line_price);
      }).join('\n');

      // 7) Mailto-links bouwen
      var shareSubject = 'Bekijk mijn winkelwagen bij VanDouglasHout';
      var shareBody = ''
        + 'Hallo,\n\n'
        + 'Ik heb een winkelwagen samengesteld bij VanDouglasHout en wil deze met je delen.\n\n'
        + 'Producten:\n'
        + productListText + '\n\n'
        + 'Totaal incl. BTW: ' + fmtPrice(cart.total_price) + '\n\n'
        + 'Klik op de onderstaande link om de winkelwagen direct in je browser te openen:\n'
        + restoreUrl + '\n\n'
        + 'Groet';
      var shareMailto = 'mailto:?subject=' + encodeURIComponent(shareSubject)
        + '&body=' + encodeURIComponent(shareBody);

      var stockSubject = 'Voorraadcheck winkelwagen';
      var stockBody = ''
        + 'Hallo VanDouglasHout team,\n\n'
        + 'Kunnen jullie laten weten of onderstaande producten op voorraad zijn?\n\n'
        + productListText + '\n\n'
        + 'Totaal incl. BTW: ' + fmtPrice(cart.total_price) + '\n\n'
        + 'Klik hier om mijn winkelwagen te bekijken:\n'
        + restoreUrl + '\n\n'
        + 'Met vriendelijke groet';
      var stockMailto = 'mailto:' + CONTACT_EMAIL
        + '?subject=' + encodeURIComponent(stockSubject)
        + '&body=' + encodeURIComponent(stockBody);

      // 8) Bouw volledige HTML-pagina
      var ORANGE = '#f07030';
      var DARK   = '#1a1a1a';
      var LOGO   = 'https://vandouglashout.com/cdn/shop/files/Vandouglashout-logozwart-onderdeelWeij-e1703148802284.png?v=1746716073&width=352';

      var html = '<!DOCTYPE html>\n<html lang="nl">\n<head>\n'
        + '<meta charset="UTF-8">\n'
        + '<meta name="viewport" content="width=device-width,initial-scale=1">\n'
        + '<title>Winkelwagen — VanDouglasHout</title>\n'
        + '<style>\n'
        + '* { box-sizing: border-box; margin: 0; padding: 0; }\n'
        + 'body { font-family: Arial, Helvetica, sans-serif; color: ' + DARK + '; background: #fff; padding: 48px; max-width: 860px; margin: 0 auto; -webkit-print-color-adjust: exact; print-color-adjust: exact; }\n'
        + '.hdr { display: flex; justify-content: space-between; align-items: center; padding-bottom: 20px; border-bottom: 3px solid ' + ORANGE + '; margin-bottom: 30px; }\n'
        + '.logo { height: 42px; width: auto; }\n'
        + '.meta { text-align: right; font-size: 13px; color: #555; line-height: 1.7; }\n'
        + '.meta strong { color: ' + DARK + '; }\n'
        + 'table { width: 100%; border-collapse: collapse; margin-bottom: 4px; font-size: 13px; }\n'
        + 'thead tr { background: ' + ORANGE + '; color: #fff; }\n'
        + 'th { padding: 10px 14px; text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 700; }\n'
        + '.totals { display: flex; justify-content: flex-end; margin: 18px 0 30px; }\n'
        + '.totals-inner { min-width: 260px; border-top: 2px solid #ebebeb; padding-top: 10px; }\n'
        + '.trow { display: flex; justify-content: space-between; padding: 4px 0; font-size: 13px; color: #444; }\n'
        + '.trow.discount { color: #e53e3e; }\n'
        + '.trow.grand { font-weight: 700; font-size: 16px; color: ' + DARK + '; border-top: 2px solid ' + DARK + '; margin-top: 8px; padding-top: 10px; }\n'

        /* ── Actieblok ── */
        + '.actions { background: #fff6f0; border: 2px solid ' + ORANGE + '; border-radius: 10px; padding: 22px 26px; margin-bottom: 28px; }\n'
        + '.actions-title { display: flex; align-items: center; gap: 8px; font-size: 15px; font-weight: 700; color: ' + ORANGE + '; margin-bottom: 8px; }\n'
        + '.actions p { font-size: 13px; color: #444; line-height: 1.6; margin-bottom: 14px; }\n'

        /* ── Buttons ── */
        + '.btn-group { display: flex; gap: 10px; flex-wrap: wrap; margin-top: 6px; }\n'
        + '.btn { display: inline-flex; align-items: center; gap: 6px; padding: 12px 20px; border-radius: 6px; font-size: 13px; font-weight: 700; text-decoration: none; line-height: 1; transition: opacity .15s; -webkit-print-color-adjust: exact; print-color-adjust: exact; }\n'
        + '.btn-primary { background: ' + ORANGE + '; color: #fff; border: 2px solid ' + ORANGE + '; }\n'
        + '.btn-secondary { background: #fff; color: ' + ORANGE + '; border: 2px solid ' + ORANGE + '; }\n'
        + '.btn:hover { opacity: .85; }\n'
        + '.tip { font-size: 12px; color: #888; margin-top: 14px; line-height: 1.5; }\n'
        + '.tip a { color: ' + ORANGE + '; }\n'

        /* ── Footer ── */
        + '.ftr { border-top: 1px solid #ebebeb; padding-top: 14px; margin-top: 10px; font-size: 11px; color: #bbb; display: flex; justify-content: space-between; align-items: center; }\n'
        + '.ftr-logo { height: 22px; width: auto; opacity: 0.4; }\n'

        /* ── Print ── */
        + '@media print {\n'
        + '  body { padding: 20px; }\n'
        + '  .btn { break-inside: avoid; }\n'
        + '  a[href]:after { content: ""; }\n' /* voorkomt automatisch URL achter links in sommige browsers */
        + '}\n'
        + '</style>\n</head>\n<body>\n'

        // ── Header ──
        + '<div class="hdr">\n'
        + '  <img class="logo" src="' + LOGO + '" alt="VanDouglasHout">\n'
        + '  <div class="meta"><strong>Opgeslagen winkelwagen</strong><br>' + datum + '</div>\n'
        + '</div>\n'

        // ── Tabel ──
        + '<table>\n'
        + '<thead><tr>'
        + '<th style="width:48%">Product</th>'
        + '<th style="width:12%;text-align:center">Aantal</th>'
        + '<th style="width:20%;text-align:right">Prijs/stk</th>'
        + '<th style="width:20%;text-align:right">Totaal</th>'
        + '</tr></thead>\n'
        + '<tbody>' + productRows + '</tbody>\n'
        + '</table>\n'

        // ── Totalen ──
        + '<div class="totals"><div class="totals-inner">\n'
        + discountRows
        + '<div class="trow grand"><span>Totaal incl. BTW</span><span>' + fmtPrice(cart.total_price) + '</span></div>\n'
        + '</div></div>\n'

        // ── Actieblok ──
        + '<div class="actions">\n'
        + '  <div class="actions-title">🛒 Wat wil je doen met deze winkelwagen?</div>\n'
        + '  <p>Open de winkelwagen direct opnieuw, deel hem met iemand anders, of vraag bij VanDouglasHout een voorraadcheck aan.</p>\n'
        + '  <div class="btn-group">\n'
        + '    <a href="' + escAttr(restoreUrl) + '" class="btn btn-primary">🛒 Open winkelwagen</a>\n'
        + '    <a href="' + escAttr(shareMailto) + '" class="btn btn-secondary">📧 Mail naar iemand anders</a>\n'
        + '    <a href="' + escAttr(stockMailto) + '" class="btn btn-secondary">📦 Vraag voorraadcheck</a>\n'
        + '  </div>\n'
        + '  <div class="tip">Tip: heb je al items in je winkelwagen? <a href="' + escAttr(clearUrl) + '">Maak je winkelwagen eerst leeg</a> voordat je de link gebruikt. '
        + 'Wil je de PDF ook als bijlage meesturen? Sla deze pagina eerst op via Ctrl+P / Cmd+P en voeg het bestand handmatig toe aan de mail.</div>\n'
        + '</div>\n'

        // ── Footer ──
        + '<div class="ftr">'
        + '<img class="ftr-logo" src="' + LOGO + '" alt="">'
        + '<span>Opgeslagen op ' + datum + '</span>'
        + '</div>\n'
        + '</body>\n</html>';

      // 9) Open als blob in nieuw tabblad
      var blob    = new Blob([html], { type: 'text/html; charset=utf-8' });
      var blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');

      // Geheugen vrijmaken na 60 seconden
      setTimeout(function () { URL.revokeObjectURL(blobUrl); }, 60000);

    } catch (err) {
      alert('Er is een fout opgetreden:\n' + err.message);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  }

  // Maak globaal beschikbaar zodat onclick="cartSavePDF()" werkt
  window.cartSavePDF = cartSavePDF;
})();